const config = {
  topMenu: false,
  rtl: localStorage?.current_language == 'en'  ? false : true,
  darkMode: false,
  mainTemplate: 'lightMode',
};

export default config;
